<template>
    <div>
        <Nav></Nav>
        <b-overlay :show="pageloading" rounded="sm">
            <PageHeader :linkto="'/profile'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <b-container class="bg-white p-3 p-md-5 shadow-sm rounded ">


            <p class="text-center mb-3">剩餘點數為 <span class="text-primary h3"> {{ userlog.Balance }} </span> 點</p>
            <b-card v-for="(item,index) in userlog.Listdata" :key="index" class="mb-3">
                    <b-avatar variant="primary"   class="mr-3 text-white" size="6rem">
                       <h2 class="my-auto"> {{ item.payment}}<span class="h6">點</span></h2>
                    </b-avatar>

                    <div class="float-right text-right">
                        <h6 class="text-muted"> 您使用<span class="text-primary"> {{ getname(item.puid) }} </span>消耗點數 <span class="text-primary"> {{ item.payment }} </span> 點</h6>
                        <p class="small text-muted">  {{ item.create_date }}</p>
                    </div>

                </b-card>

            <b-card v-if="userlog.length==0" class="mb-2">
                <b-card-text>
                    <b-img center :src="require('../../assets/ui/emptybox.png')"  v-bind="{  width: 75, height: 75}"></b-img>
                    <p class="text-muted text-center">沒有任何紀錄資料</p>
                </b-card-text>
            </b-card>
            <b-button variant="primary" block @click="loadmore" v-if="!ListinEnd && !loadmoreswitch">讀取更多</b-button>

            <b-alert show variant="primary" class="d-flex justify-content-center pb-5 pt-5" v-if="loadmoreswitch">
                <b-spinner label="Loading..."></b-spinner>
                <strong class="ml-3 mt-2">讀取中</strong>
            </b-alert>
            <b-alert show variant="primary" class="d-flex justify-content-center pb-5 pt-5" v-if="ListinEnd && !loadmoreswitch">已無資料</b-alert>

        </b-container>

        </b-overlay>



    </div>


</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'

import {productdata} from '@/config/env';
import {puidtotitle} from '@/service/commuse'
import {mapState} from 'vuex'

export default {
  name: 'login',
  components: {Nav,PageHeader},
  data () {
    return {
      productName:'點數消費紀錄',
      pageloading: true,
      offset: 0,
      limite:20,
      loadmoreswitch:false,
      isLoadMore:false,
      ListinEnd:false,
    }
  },
  computed: {
    ...mapState(['userlog']),
    rows() {
      return this.items.length
    }
  },
  created() {
    this.$store.dispatch('actionGetOrderLog', {
      limit: this.limite,
      offset: this.offset
    }).then((res)=>{
      this.pageloading=false
    });
  },
  mounted () {
    // document.addEventListener("scroll",this.handleScroll)
  },
  methods: {
    getname(puid){
      return puidtotitle(puid)
    },
    loadmore() {

      if (!this.loadmoreswitch) {

        this.offset = this.offset + 1

        // this.offset = this.offset + (this.limite+ 1)
        // this.offset = (this.offset+1) * this.limite
        this.loadmoreswitch = true
        this.$store.dispatch('actionGetOrderLog', {
          limit: this.limite,
          offset: this.offset
        }).then((res) => {

          if (res.data.length == 0) {
            this.ListinEnd = true
            setTimeout(() => {
              this.ListinEnd = false
            }, 3000)

          }

          this.loadmoreswitch = false


        });
      }
    },
    handleScroll() {
      if(this.$route.path== '/UsementLog'){

        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        let total = scrollTop+windowHeight;
        if(total == scrollHeight && this.isLoadMore ){
          this.loadmore()
          this.isLoadMore = false

        }
        if(total < scrollHeight  ){
          this.isLoadMore = true
        }
      }

    },

  }
}
</script>
